
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 20.925 22.827"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M10.463 0L0 5.707v11.538l10.463 5.582 10.462-5.582V5.767zm-.951 20.164l-6.339-3.381 4-2.664c1.027-.684-.063-2.244-1.182-1.5l-4.084 2.722V7.826l7.609 4.15zM2.98 6.249l6.532-3.563v4.21a.951.951 0 001.9 0v-4.2l6.572 3.625-7.518 4.012zm8.434 5.735l7.609-4.06v7.419l-4.055-2.7c-1.123-.747-2.209.813-1.184 1.5l3.968 2.645-6.338 3.382z","fill":"#fff"}})])
          )
        }
      }
    